// extracted by mini-css-extract-plugin
module.exports = {"more":"More_more__xlOQ7"};